import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUserData } from "../../store/actions/userDataActions";
import TalentsApiService from "../../TalentsApiService";
import * as Utilities from "../../Utilities";
import ChangePassword from "./ChangePassword";
import { t } from "../../content";
import { useLocale } from "../../locale";

import Form from "../../components/reusableElementsComponents/Form";
import Button from "../../components/reusableElementsComponents/Button";
import Loading from "../../components/reusableElementsComponents/Loading";
import Loader from "../../components/reusableElementsComponents/Loader";
import PageLayout from "../../components/layoutComponents/PageLayout";

import person from "../../assets/images/icons/person.svg";
import letter from "../../assets/images/icons/letter.svg";
import editIcon from "../../assets/images/icons/editIcon.png";
import cog from "../../assets/images/icons/cog.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { ToastContainer, toast } from "react-toastify";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

function Settings() {
  const { locale } = useLocale();
  const initialUserInfo = useSelector((state) => state.userData?.all?.["info"]);
  const [userInfo, setUserInfo] = useState({});
  const [template, setTemplate] = useState({});
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const talentsServiceObj = useMemo(() => {
    return new TalentsApiService();
  }, []);

  useEffect(() => {
    if (initialUserInfo?.first) {
      setUserInfo(initialUserInfo);
    } else {
      talentsServiceObj.GetCurrentUserDetails((json) => {
        setUserInfo(json);
        dispatch(setUserData({ all: json }));
      });
    }
  }, [initialUserInfo, talentsServiceObj, dispatch]);

  const onSubmit = (values) => {
    setLoader(true);
    const savingDetails = toast.loading(t("account.toasts.updatingDetails"));
    talentsServiceObj
      .SaveUserData({
        first: values.firstname.length > 0 ? values.firstname : userInfo.first,
        last: values.lastname.length > 0 ? values.lastname : userInfo.last,
        email:
          values.emailaddress.length > 0 ? values.emailaddress : userInfo.email,
      })
      .then((res) => {
        if (res.httpStatus === 200) {
          toast.update(savingDetails, {
            render: t("account.toasts.detailsSaved"),
            type: "success",
            isLoading: false,
            autoClose: "2000",
            closeButton: true,
            hideProgressBar: true,
          });
          setLoader(false);
          window.scrollTo(0, 0);
        } else {
          toast.update(savingDetails, {
            render: t("account.toasts.detailsError"),
            type: "error",
            isLoading: false,
            autoClose: "2000",
            closeButton: true,
            hideProgressBar: true,
          });
          setLoader(false);
          window.scrollTo(0, 0);
        }
      });
  };

  useEffect(() => {
    if (!Utilities.isEmptyObject(userInfo)) {
      setTemplate({
        fields: [
          {
            title: t("common.fields.firstName"),
            type: "text",
            name: "firstName",
            placeholder: t("common.placeholders.startTyping"),
            icon: person,
            defaultValue: userInfo?.first,
          },
          {
            title: t("common.fields.lastName"),
            type: "text",
            name: "lastName",
            placeholder: t("common.placeholders.startTyping"),
            icon: person,
            defaultValue: userInfo?.last,
          },
          {
            title: t("common.fields.emailAddress"),
            type: "email",
            name: "emailAddress",
            placeholder: t("common.placeholders.startTyping"),
            defaultValue: userInfo?.email,
            icon: letter,
          },
        ],
      });
    }
  }, [userInfo, locale]);

  return (
    <>
      <div className="bg-cover">
        <PageLayout>
          <div className="section-wrapper">
            <h1>{t("account.title")}</h1>
          </div>
        </PageLayout>
        <div className="settings-page-layout-wrapper">
          <div className="inner-layout">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Col sm={12} className="d-flex vp-1200">
                <div>
                  <Nav
                    variant="pills"
                    className="flex-column bg-white py-3 px-2 mb-3 rounded"
                    style={{ width: "300px" }}
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="first">
                        {" "}
                        <img className="m-2" src={cog} alt="settings" />
                        {t("account.general")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">
                        {" "}
                        <img
                          height="20px"
                          className="m-2"
                          src={editIcon}
                          alt="change-password"
                        />{" "}
                        {t("account.changePassword")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <Tab.Content className="w-100">
                  <Tab.Pane eventKey="first">
                    <div className="settings-page">
                      <div className="settings-form">
                        {userInfo.first &&
                        !Utilities.isEmptyObject(template) ? (
                          <Form
                            template={template}
                            watchFields={["first", "last"]}
                            onSubmit={onSubmit}
                          >
                            {loader ? (
                              <Button btnstyle={"mazhrBtn light-grey"}>
                                <Loader />
                              </Button>
                            ) : (
                              <Button
                                type="submit"
                                btnstyle={"mazhrBtn default-green white"}
                                onSubmit={onSubmit}
                              >
                                {t("account.saveChanges")}
                              </Button>
                            )}
                            <div className="flex mar-20 top">
                              <InfoOutlinedIcon
                                className="mar-15 right"
                                style={{
                                  fontSize: "2em",
                                }}
                              />
                              <p>{t("account.deleteAccount")}</p>
                            </div>
                          </Form>
                        ) : (
                          <Loading
                            sectionLoading={true}
                            containerHeight={"400px"}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <ChangePassword />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}

export default Settings;
